import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import { convertToStandard } from 'appSrc/utils/list-article';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import style from './styles/style.module.css';

import defaultListCoverImage from 'appSrc/assets/img/list/default_list_image.png';


class ContentFocusedLACard extends PureComponent {
    constructor(props) {
        super( props );

        this.state = {
            videoPlaying: false,
        };
    }
    renderCoverImage = ( item ) => {
        const youtubeImg = item.video_id && convertYouTubeIdToImg( item.video_id );
        const coverImage = item.cover_image || youtubeImg || defaultListCoverImage;

        return (
            <div className={ style.imageWrapper }>
                <img src={ coverImage } />
            </div>
        );
    }
    render() {
        const item = convertToStandard( this.props.item );
        const author = item.author || {};
        const profession = ( author.profession || {} ).title;

        const movieMetaData = {
            attached_to: `${ item.type }_cover_video`,
            attached_id: item.id,
            video_author_id: item.userid,
        };

        return (
            <div className={ `${ style.contextFocusedCard } ${ this.props.className }`.trim() }>
                <Link to={ item.internal_link } style={ { zIndex: 2, display: 'block' } }>
                    <AspectRatio ratio='16/9' className={ style.coverWrapper }>
                        { this.renderCoverImage( item ) }
                        <div className={ style.overlayInfo }>
                            <div className={ style.info }>

                                <p className={ style.name }>{ item.title }</p>
                                <p className={ style.userName }>{ author.displayName }</p>
                                <p className={ style.profession }>{ profession }</p>
                            </div>
                            { item.video_id &&
                                <TheaterPlayIcon className={ style.playButton } youtubeId={ item.video_id }
                                metaData={ movieMetaData } />
                            }
                        </div>
                    </AspectRatio>
                </Link>
            </div>
        );
    }
}
ContentFocusedLACard.propTypes = {
    item: PropTypes.object.isRequired,
};
ContentFocusedLACard.defaultProps = {
    className: '',
};

export default connect()( ContentFocusedLACard );
